import { render, staticRenderFns } from "./PorIndicador.vue?vue&type=template&id=8a559e46"
import script from "./PorIndicador.vue?vue&type=script&lang=js"
export * from "./PorIndicador.vue?vue&type=script&lang=js"
import style0 from "./PorIndicador.vue?vue&type=style&index=0&id=8a559e46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports